const PlayerDetails = () => import(/* webpackChunkName: "PlayerOverview" */ './containers/PlayerDetails');
const PlayerList = () => import(/* webpackChunkName: "PlayerList" */ './containers/PlayersGrid');
const PlayersKycGrid = () => import(/* webpackChunkName: "PlayerGrid" */ './containers/PlayersKycGrid');
const PlayerOverview = () => import(/* webpackChunkName: "PlayerOverviewR" */ './components/PlayerOverview');
const PlayerKYC = () => import(/* webpackChunkName: "PlayerKYC" */ './components/PlayerKYC');
const PlayerWalletsHistory = () => import(/* webpackChunkName: "PlayerWalletsHistory" */ './components/PlayerWalletsHistory');
const PlayerTransactionsHistory = () => import(/* webpackChunkName: "PlayerTransactionsHistory" */ './components/TransactionsHistory');
const PlayerGameHistory = () => import(/* webpackChunkName: "PlayerGameHistory" */ './components/PlayerGameHistory');
const PlayerLoginHistory = () => import(/* webpackChunkName: "PlayerLoginHistory" */ './components/PlayerLoginHistory');
const PlayerNotes = () => import(/* webpackChunkName: "PlayerLoginHistory" */ './components/PlayerNotes');
const PlayerMessages = () => import(/* webpackChunkName: "PlayerMessages" */ './components/PlayerMessages');
const PlayerStatistics = () => import(/* webpackChunkName: "PlayerStatistics" */ './components/PlayerStatistics');

export const playersRouting = [
    {path: '/players', name: 'player-list', component: PlayerList},
    {path: '/players-kyc', name: 'players-kyc', component: PlayersKycGrid},
    {
        path: '/player/:id', component: PlayerDetails,
        children: [
            {path: '/', redirect: 'details'},
            {path: 'details', name: 'player-details', component: PlayerOverview},
            {path: 'kyc', name: 'player-kyc', component: PlayerKYC},
            {path: 'wallets-history', name: 'player-wallets', component: PlayerWalletsHistory},
            {path: 'transactions-history', name: 'player-transactions', component: PlayerTransactionsHistory},
            {path: 'game-history', name: 'player-game-history', component: PlayerGameHistory},
            {path: 'login-history', name: 'player-login-history', component: PlayerLoginHistory},
            {path: 'notes', name: 'player-notes', component: PlayerNotes},
            {path: 'player-messages', name: 'player-messages', component: PlayerMessages},
            {path: 'player-statistics', name: 'player-statistics', component: PlayerStatistics}
        ]
    },
]
